<template>
  <div :class="`col-${width || 100}`">
    <div class="mb-4">
      <span class="label">{{ label }}</span>
    </div>
    <v-radio-group
      v-model="value"
      v-validate="validator"
      row
      single-line
      data-vv-validate-on="change|input"
      :error-messages="errors.first(field)"
      :name="field"
      :disabled="disabled"
    >
      <v-radio v-for="option in options" :key="option.id" :label="option.label" :value="option.value" />
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: 'FormRadio',
  inject: ['$validator'],
  props: {
    id: String,
    label: String,
    name: String,
    options: {
      type: Array,
      default: () => {}
    },
    width: {
      type: Number,
      default: 100
    },
    field: String,
    validator: Object,
    backend: {
      type: Array,
      default: () => []
    },
    mask: {
      default: null,
      type: String
    },
    placeholder: {
      default: null,
      type: String
    },
    extra_data: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null,
    value: ''
  }),
  computed: {
    componentValue() {
      const obj = { [this.field]: this.value }
      return this.extra_data ? { extra_data: obj } : obj
    }
  },
  mounted() {
    let fieldValue = this.$store.getters.USER_INFO[this.field]
    if (this.extra_data) {
      fieldValue = this.$store.getters.USER_INFO.extraData?.[this.field]
    }
    if (this.$store.getters.TOKEN && fieldValue) {
      this.value = fieldValue
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
.v-messages__message {
  padding-left: 12px;
  margin-bottom: 8px;
}
</style>
